import React from 'react';

export default function PageShell({ variant = 'standard', className = '', children }) {
    const shellClass =
        variant === 'singleTable'
            ? 'tableContainer dashboard-shell single-table-page__shell'
            : 'tableContainer dashboard-shell';
    const classes = [shellClass, className].filter(Boolean).join(' ');
    return <div className={classes}>{children}</div>;
}
